import { render, staticRenderFns } from "./class-warn-dialog.vue?vue&type=template&id=4535a4ee"
import script from "./class-warn-dialog.vue?vue&type=script&lang=ts"
export * from "./class-warn-dialog.vue?vue&type=script&lang=ts"
import style0 from "./class-warn-dialog.vue?vue&type=style&index=0&id=4535a4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports